import React, { useState, useEffect } from 'react';
import '../../../assetss/styles/tictacOneCopy.css'

const winCombos = [
  [0, 1, 2], [3, 4, 5], [6, 7, 8],   //horizontal
  [0, 3, 6], [1, 4, 7], [2, 5, 8],   //vertical
  [0, 4, 8], [6, 4, 2]               //diagonal
];

const WinLine = (props) => {
  const lines = ['horizTop', 'horizMid', 'horizBtm', 'vertL', 'vertM', 'vertR', 'diagL', 'diagR'];
  var showWinLine = (props.showLine) ? 'vis' : 'invis';
  var lineToShow = `${lines[props.lineId]} vis drawLine`;
  return (
    <div className="d-flex justify-content-center">
      <svg height="3" width="0" className={(props.showLine) ? lineToShow : 'invis'}>
        <line x1="0" y1="0" x2="400" y2="0" />
      </svg>
    </div>
  );
}

const Menu = (props) => {
  var showMenu = (props.menuVisible) ? 'show' : 'hide';
  return (
    <div className={showMenu}>
      <div id="char-selection" className="container mx-auto pb-4 ">
        {/* <h1 id="game-header" className="text-center text-light border-bottom">بازی دوز یک نفره</h1> */}
        <div className="row justify-content-center">
          <div className="col-12 text-white text-center py-3">
            <h3>انتخاب کارکتر</h3>
          </div>
        </div>
        <div className=" flex justify-center gap-8 row justify-content-center">
          <div className="col-sm-4 text-center py-2">
            <button id="x-char" className="px-3 py-2 rounded-md bg-red-400 " onClick={props.charSelect}>X</button>
          </div>
          <div className="col-sm-4 text-center py-2">
            <button id="o-char" className="btn px-3 py-2 rounded-md bg-blue-400 char-btn" onClick={props.charSelect}>O</button>
          </div>
        </div>
      </div>
    </div>
  );
};
 
const Board = (props) => {
  var showBoard = (props.menuVisible) ? 'hide' : 'show';
  var turnTrue = 'whoTurn badge badge-success', turnFalse = 'whoTurn badge badge-secondary';
  var showResult = (props.result === '') ? 'hide' : 'show';
  return (
    <div className={showBoard}>
      <div className="flex justify-center items-center mx-auto">
        <p id='result-message' className={showResult}>{props.result}</p>
      </div>
      <div className="flex justify-center items-center mx-auto">
        <div id="turn-indicator" >
          <h1 className='font-semibold text-center'>بازی دوز یک نفره</h1>
          <div className='text-center mt-1'>
          </div>
        </div>
      </div>
      <div id="game-board" className=" flex justify-center  p-3 mb-24 ">
        <div className="row justify-content-center">
          <div className="col-">
            <table>
              <tr>
                <td id="0" className="cell" onClick={props.handleClick} ></td>
                <td id="1" className="cell" onClick={props.handleClick} ></td>
                <td id="2" className="cell" onClick={props.handleClick} ></td>
              </tr>
              <tr>
                <td id="3" className="cell" onClick={props.handleClick} ></td>
                <td id="4" className="cell" onClick={props.handleClick} ></td>
                <td id="5" className="cell" onClick={props.handleClick} ></td>
              </tr>
              <tr>
                <td id="6" className="cell" onClick={props.handleClick} ></td>
                <td id="7" className="cell" onClick={props.handleClick} ></td>
                <td id="8" className="cell" onClick={props.handleClick} ></td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

const TicTacToeGameOne = () => {
  const [state, setState] = useState({
    gameBoard:   Array.from(Array(9).keys()),
    menuVisible: true,
    showLine:    false,
    turn:        'X',
    turnToggler: 'X',
    user:        '',
    ai:          '',
    result:      '',
    winLine:     ''
  });

  const startGame = () => {
    setState({
      gameBoard:   Array.from(Array(9).keys()),
      menuVisible: true,
      showLine:    false,
      turn:        'X',
      turnToggler: 'X',
      user:        '',
      ai:          '',
      result:      '',
      winLine:     '',
    });
    let cells = document.querySelectorAll('.cell');
    for (let i = 0; i < cells.length; i++) {
      cells[i].innerText = '';
      cells[i].style.backgroundColor = 'initial';
      cells[i].style.pointerEvents = 'initial';
    }
  };
  
  const charSelect = (e) => {
    let userCharacter = e.currentTarget.innerHTML;
    let aiCharacter = (userCharacter === 'X') ? 'O' : 'X';
    setState(prevState => ({
      ...prevState,
      user: userCharacter,
      ai: aiCharacter,
      menuVisible: false
    }));
    if (aiCharacter === 'X') {
      changeTurn(bestSpot(), aiCharacter);
    }
  };
  
  const handleClick = (gameSpace) => {
    const {gameBoard, turn, user, ai} = state;
    if (typeof gameBoard[gameSpace.currentTarget.id] === 'number') {
      changeTurn(gameSpace.currentTarget.id, user);
      if (!checkWin(gameBoard, user) && !checkTie()) {
        setTimeout( () => changeTurn(bestSpot(), ai), 10);
      }
    }
  };

  const emptySquares = () => {
    return state.gameBoard.filter((ele, idx) => idx === ele);
  };

  const gameOver = (gameWon) => {
    const {ai, user} = state;
    setState(prevState => ({
      ...prevState,
      result:   gameWon.player + ' برنده!',
      winLine:  gameWon.index,
      showLine: true
    }));
    if (gameWon.player === ai) {
      playSound('ai');
    } else {
      playSound('user');
    }
  };
  
  const playSound = (winner) => {
    var sample = {
      'user': 'https://freesound.org/data/previews/253/253177_4404552-lq.mp3',
      'ai':   'https://freesound.org/data/previews/253/253174_4404552-lq.mp3',
      'tie':  'https://freesound.org/data/previews/178/178884_3327025-lq.mp3'
    };
    var audio = new Audio(sample[winner]);
    audio.play();
  };

  const minMax = (testBoard, player) => {
    const {ai, user} = state;
    
    var openSpaces = emptySquares(testBoard);
    
    if (checkWin(testBoard, user)) {
      return {score: -10};
    } else if (checkWin(testBoard, ai)) {
      return {score: 10};
    } else if (openSpaces.length === 0) {
      return {score: 0};
    }
    
    var moves = [];
    
    for (let i = 0; i < openSpaces.length; i++) {
      var move = {};
      move.index = testBoard[openSpaces[i]];
      testBoard[openSpaces[i]] = player;
    
      if (player === ai) 
        move.score = minMax(testBoard, user).score;
      else
        move.score =  minMax(testBoard, ai).score;
        testBoard[openSpaces[i]] = move.index;
      if ((player === ai && move.score === 10) || (player === user && move.score === -10))
        return move;
      else
        moves.push(move);
    }
  
    let bestMove, bestScore;
  
    if (player === ai) {
      bestScore = -1000;
      for (let i = 0; i < moves.length; i++) {
        if (moves[i].score > bestScore) {
          bestScore = moves[i].score;
          bestMove = i;
        }
      }
    } else {
      bestScore = 1000;
      for (let i = 0; i < moves.length; i++) {
        if (moves[i].score < bestScore) {
          bestScore = moves[i].score;
          bestMove = i;
        }
      }
    }  
  return moves[bestMove];
  };
  
  const bestSpot = () => {
    return minMax(state.gameBoard, state.ai).index;
  };
  
  const checkTie = () => {
    if (emptySquares().length === 0) {
      setState(prevState => ({
        ...prevState,
        result: 'بازی مساوی'
      }));
      playSound('tie');
      return true;
    }
    return false;
  };
  
  const checkWin = (board, player) => {
    const {gameBoard} = state;
        
    let spaces = board.reduce((acc, ele, idx) => (ele === player) ? acc.concat(idx) : acc, []);
    let gameWon = null;
    
    for (let [index, win_combos] of winCombos.entries()) {
      if (win_combos.every(comboSpace => spaces.indexOf(comboSpace) > -1)) {
        gameWon = {index: index, player: player};
        break;
      }
    }
    return gameWon;
  };
  
  const changeTurn = (spaceId, player) => {
    const {gameBoard, turn, turnToggler} = state;
    
    let game_board = gameBoard;
    game_board[spaceId] = player;
    
    let turnUpdate = (turnToggler === 'X') ? 'O' : 'X';
    
    setState(prevState => ({
      ...prevState,
      gameBoard:   [...game_board],
      turnToggler: turnUpdate
    }));
    
    document.getElementById(spaceId).innerHTML = player;
    document.getElementById(spaceId).style.pointerEvents = 'none';
    
    let gameWon = checkWin(game_board, player);
    if (gameWon) {
      gameOver(gameWon);
    }
    checkTie();
  };

  var showPlayButton = (state.result === '') ? 'invis' : 'vis d-flex justify-content-center';
  return (
    <div>
      <div className={showPlayButton}>
        <button id="replay-button" className=" flex justify-center mx-auto p-1 rounded-md mt-2 bg-red-400" onClick={startGame}> شروع بازی</button>
      </div>
      <Menu 
        menuVisible={state.menuVisible}
        charSelect={charSelect}  
      />
      <WinLine 
        showLine={state.showLine}
        lineId={state.winLine}
      />
      <Board 
        result={state.result}
        turn={state.turnToggler}
        handleClick={handleClick}
        menuVisible={state.menuVisible}  
      />
    </div>
  );
};
export default TicTacToeGameOne;